// extracted by css-extract-rspack-plugin
export default {"area":"CardActionArea_area__jX7RJ"};